import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { ParametrosApi } from '../api/Parametros.api';
import { IParametroDTO } from '../dto/parametro-dto';
import { IParametro } from '../models/parametro';
import { Observable } from 'rxjs';

@Injectable()
export class ParametrosService extends ServiceBase<IParametro, IParametroDTO> {

    constructor(private api: ParametrosApi) {
        super(api);
    }
    public getLogo(): Observable<any> {
        return this.api.getLogo();
    }
}
